import { callable } from '../callable';

// H10: dar acceso a un grupo (admissionsDispatch → grantGroupAccess).

export type AccessGroup =
  | { kind: 'faculty' }
  | { kind: 'termFaculty' | 'term' | 'program'; id: string };

export type AccessSkipReason =
  | 'no_email'
  | 'placeholder_email'
  | 'deceased'
  | 'email_shared'
  | 'already_has_access';

export interface AccessPreviewDto {
  role: 'faculty' | 'student';
  total: number;
  eligible: Array<{ personId: string; name: string; email: string }>;
  skipped: Record<AccessSkipReason, number>;
  /** Solo en el grupo de todos los profesores: cuántos no tienen ninguna
   *  sección en los dos últimos períodos (aviso; no cambia a quién se da). */
  withoutRecentSection?: number;
}

export type AccessRowDto =
  | { personId: string; result: 'created' | 'added'; emailSuppressed: boolean }
  | { personId: string; result: 'skipped'; reason: string }
  | { personId: string; result: 'error'; reason: string };

export const groupAccessApi = {
  preview: async (data: { tenantId: string; group: AccessGroup }) => {
    const fn = callable<object, AccessPreviewDto>('grantGroupAccess');
    return (await fn({ ...data, mode: 'preview' })).data;
  },
  start: async (data: { tenantId: string; group: AccessGroup; confirmCount: number }) => {
    const fn = callable<object, { sessionId: string; personIds: string[]; batch: number }>(
      'grantGroupAccess',
    );
    return (await fn({ ...data, mode: 'start' })).data;
  },
  run: async (data: { tenantId: string; sessionId: string; personIds: string[] }) => {
    const fn = callable<object, { rows: AccessRowDto[] }>('grantGroupAccess');
    return (await fn({ ...data, mode: 'run' })).data;
  },
};
